import { cx } from "class-variance-authority";
import type { PropsWithChildren } from "react";
import { Button, DialogTrigger, Popover, type PopoverProps } from "react-aria-components";

interface DropdownProps extends PropsWithChildren {
  trigger?: React.ReactNode;
  customTrigger?: React.ReactNode;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  popoverProps?: PopoverProps;
  "data-testid"?: string;
}

export const Dropdown = ({
  trigger,
  customTrigger,
  children,
  isOpen,
  setIsOpen,
  popoverProps,
  "data-testid": dataTestId,
}: DropdownProps) => {
  let element: React.ReactNode = null;
  if (customTrigger) {
    element = customTrigger;
  } else {
    element = (
      <Button
        className="flex w-fit cursor-pointer justify-start outline-hidden"
        data-testid={dataTestId}
      >
        {trigger}
      </Button>
    );
  }

  return (
    <DialogTrigger
      isOpen={isOpen}
      onOpenChange={setIsOpen}
    >
      {element}
      <Popover
        {...popoverProps}
        className={cx("w-60 rounded-xs bg-secondary-300 p-5 shadow-1", popoverProps?.className)}
      >
        {children}
      </Popover>
    </DialogTrigger>
  );
};
